import React, { useState } from 'react';
import './InstructionsScreen.css';

const InstructionsScreen = ({ hasAcceptedTerms, onAccept, onBack }) => {
  const [isAccepted, setIsAccepted] = useState(hasAcceptedTerms);

  const handleAccept = () => {
    if (isAccepted) {
      onAccept();
    }
  };

  const instructions = [
    {
      type: 'paragraph',
      content: 'عزيزي ولي الأمر :'
    },
    {
      type: 'paragraph',
      content: 'نودّ التأكيد على أن هذه المراجعات شاملة لجميع أجزاء المنهج الدراسي، وقد تم إعدادها لتكون مرجعًا أساسيًا يساعد الطّالب على الإلمام الكامل بالمنهج الدراسي.'
    },
    {
      type: 'paragraph',
      content: 'ونظرًا لأن الاختبارات أصبحت الآن اختبارات وزارية تُعدّ مركزيًا من قبل إدارة التعليم ، ولا علاقة للمدرسة بوضع أسئلة الاختبار،'
    },
    {
      type: 'paragraph',
      content: 'عليه ..فإننا نؤكد على أهمية قيام الطالب بـ:'
    },
    {
      type: 'list',
      items: [
        'مراجعة جميع أوراق المراجعات المرسلة عبر الرابط بشكل كامل ودقيق.',
        'طباعة أوراق المراجعات وإحضارها إلى المدرسة ليتم حلّها مع المعلم داخل الصف لتعزيز الفهم ومعالجة أي صعوبات.'
      ]
    },
    {
      type: 'paragraph',
      content: 'عزيزي ولي الأمر :'
    },
    {
      type: 'paragraph',
      content: 'إن تعاونكم ومتابعتكم المستمرة ضروريّان لدعم أبنائنا وتحقيق أفضل النتائج في الاختبارات الوزارية.'
    },
    {
      type: 'paragraph',
      content: 'شاكرين لكم حرصكم وتعاونكم الدائم.'
    }
  ];

  return (
    <div className="instructions-screen">
      <div className="instructions-container" style={{ position: 'relative' }}>
        {onBack && (
          <button 
            className="back-button ripple-effect magnetic-button" 
            onClick={onBack}
          >
            ← رجوع
          </button>
        )}
        <div className="instructions-header">
          <h1 className="instructions-title">تعليمات لولي الأمر</h1>
        </div>
        
        <div className="instructions-content">
          <div className="instructions-text">
            {instructions.map((item, index) => (
              <div
                key={index}
                className={`instruction-item stagger-item ${item.type === 'paragraph' ? 'paragraph' : 'list-container'}`}
                style={{
                  animationDelay: `${index * 0.1}s`
                }}
              >
                {item.type === 'paragraph' ? (
                  <p className="instruction-paragraph">{item.content}</p>
                ) : (
                  <ol className="instruction-list">
                    {item.items.map((listItem, listIndex) => (
                      <li key={listIndex} className="instruction-list-item">{listItem}</li>
                    ))}
                  </ol>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="instructions-footer">
          <label className="accept-checkbox">
            <input
              type="checkbox"
              checked={isAccepted}
              onChange={(e) => setIsAccepted(e.target.checked)}
            />
            <span>قرأت التعليمات</span>
          </label>
          
          <button
            className={`accept-button ripple-effect magnetic-button ${isAccepted ? 'enabled pulse-strong' : 'disabled'}`}
            onClick={handleAccept}
            disabled={!isAccepted}
          >
            استمرار
          </button>
        </div>

        <div className="instructions-page-footer">
          <p>مدير المدرسة: محمد نصر الدين</p>
        </div>
      </div>
    </div>
  );
};

export default InstructionsScreen;

